import React from 'react'
import { clsx } from 'clsx'

interface SplitLayoutProps {
  main: React.ReactNode
  sidebar: React.ReactNode
  className?: string
}

export const SplitLayout: React.FC<SplitLayoutProps> = ({ main, sidebar, className }) => {
  return (
    <div className={clsx('flex flex-col gap-6 lg:flex-row', className)}>
      <div className="min-w-0 flex-1">{main}</div>
      <div className="w-full lg:w-80 lg:flex-shrink-0">{sidebar}</div>
    </div>
  )
}

export default SplitLayout
